<style>
.hello {
  height: 600px !important;
  margin-top: 20px;
}
</style>

<template>
  <div style="padding:30px;background-color:#fff">
    <div>
      <b
        ><h3>{{ title }}</h3></b
      >
    </div>
    <br />
    <v-layout>
      <v-toolbar style="box-shadow:none;background-color:#fff">
        <v-layout>
          <!-- <v-row>
            <v-col>
              <div>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="date"
                      label="Start Date"
                      append-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="$refs.menu.save(date)"
                      >Cancel</v-btn
                    >
                    <v-btn text color="primary" @click="$refs.menu.save(date)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-menu>
              </div>
            </v-col>
            <v-col>
              <div>
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  :return-value.sync="date2"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="date2"
                      label="End Date"
                      append-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date2" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="$refs.menu2.save(date2)"
                      >Cancel</v-btn
                    >
                    <v-btn text color="primary" @click="$refs.menu2.save(date2)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-menu>
              </div>
            </v-col>
            <v-col>
              <v-select
                item-text="plant_name"
                item-value="plant_code"
                v-model="plant"
                :items="list_plant"
                label="Choose Plant"
              ></v-select>
            </v-col>
            <v-col>
              <div>
                <v-btn color="primary" depressed v-on:click="getData">
                  Search
                </v-btn>

                <v-btn
                  class="ml-2"
                  color="success"
                  depressed
                  dark
                  v-on:click="reset"
                >
                  Clear Filter
                </v-btn>

                <v-progress-circular
                  indeterminate
                  class="ml-2"
                  color="primary"
                  v-if="loading"
                ></v-progress-circular>
              </div>
            </v-col>
          </v-row> -->

          <v-row>
            <v-row>
              <v-col cols="7">
                <v-btn color="primary" depressed v-on:click="formSearch()">
                  Filter
                </v-btn>

                <v-btn
                  class="ml-2"
                  color="success"
                  depressed
                  dark
                  v-on:click="reset"
                >
                  Clear Filter
                </v-btn>

                <v-btn
                  class="ml-2"
                  color="#1e6d42"
                  dark
                  :loading="loadingDownload"
                  v-on:click="exportData()"
                >
                  <v-icon dark style="margin-right:10px"
                    >mdi-microsoft-excel</v-icon
                  >
                  Export
                </v-btn>
              </v-col>

              <v-col>
                <div align="right" style="margin-top: -10px;">
                  <v-text-field
                    label=""
                    v-model="param_search"
                    placeholder="Enter Your Keywords"
                    solo
                    v-on:keyup.enter="getData()"
                    append-icon="search"
                    @click:append="getData()"
                  ></v-text-field>
                </div>
              </v-col>
            </v-row>
          </v-row>
        </v-layout>
      </v-toolbar>
    </v-layout>

    <div class="mt-5">
      <v-data-table
        :headers="headers"
        :items="data"
        :items-per-page="10"
        :footer-props="{
          'items-per-page-options': [10, 25],
        }"
      >
        <template v-slot:item.status="{ item }">
          <v-btn
            v-if="item.status === 'CAT' && !item.cataloguer"
            depressed
            x-small
            class="white--text"
            color="#0097A7"
          >
            Waiting Cataloguing (Queue)
          </v-btn>

          <v-btn
            v-else-if="item.status === 'CAT' && item.cataloguer"
            depressed
            x-small
            class="white--text"
            color="#0097A7"
          >
            Waiting Cataloguing (On List)
          </v-btn>

          <status
            v-else
            :status="item.status"
            @eventDetail="openModalDetail(item)"
          ></status>
        </template>

        <template v-slot:item.cataloguer_datediff="{ item }">
          <div>
            <b>{{
              item.cataloguer_datediff >= 0 ? item.cataloguer_datediff : 0
            }}</b>
          </div>
        </template>

        <template v-slot:item.approver_datediff="{ item }">
          <div>
            <b>{{
              item.approver_datediff >= 0 ? item.approver_datediff : 0
            }}</b>
          </div>
        </template>

        <template v-slot:item.register_sap_datediff="{ item }">
          <div>
            <b>{{
              item.register_sap_datediff >= 0 ? item.register_sap_datediff : 0
            }}</b>
          </div>
        </template>
      </v-data-table>
    </div>

    <v-dialog v-model="form_search" max-width="700px">
      <v-card>
        <v-card-title> Filter List </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <label>Material Number</label>
              <v-text-field
                v-model="material_number"
                label="Material Number"
                solo
                hide-details
              ></v-text-field>
            </v-col>

            <v-col cols="6">
              <label>Request Number</label>
              <v-text-field
                v-model="request_no"
                label="Request Number"
                solo
                hide-details
              ></v-text-field>
            </v-col>

            <v-col cols="6">
              <div>
                <label>Start Date</label>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="date"
                      label="Choose Date"
                      append-icon="event"
                      readonly
                      solo
                      v-on="on"
                      hide-details
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false"
                      >Cancel</v-btn
                    >
                    <v-btn text color="primary" @click="$refs.menu.save(date)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-menu>
              </div>
            </v-col>

            <v-col cols="6">
              <div>
                <label>End Date</label>
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  :return-value.sync="date2"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="date2"
                      label="Choose Date"
                      append-icon="event"
                      readonly
                      solo
                      v-on="on"
                      hide-details
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date2" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu2 = false"
                      >Cancel</v-btn
                    >
                    <v-btn text color="primary" @click="$refs.menu2.save(date2)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-menu>
              </div>
            </v-col>

            <v-col cols="6">
              <label class="mt-5"> Plant </label>
              <v-select
                item-text="plant_name"
                item-value="plant_code"
                v-model="plant"
                :items="list_plant"
                label="Choose Plant"
                hide-details
                solo
              ></v-select>
            </v-col>

            <v-col cols="6">
              <div>
                <label>Cataloguer</label>
                <v-autocomplete
                  item-text="NAME"
                  item-value="USER_ID"
                  v-model="cataloguer"
                  :items="list_cataloguer"
                  label="Choose Cataloguer"
                  solo
                  hide-details
                ></v-autocomplete>
              </div>
            </v-col>

            <v-col cols="6">
              <label> Status </label>
              <v-select
                item-text="STATUS_NAME"
                item-value="STATUS_ID"
                v-model="filter_status"
                :items="list_status"
                label="Choose Status"
                solo
              ></v-select>
            </v-col>
          </v-row>

          <div align="right">
            <v-btn rounded depressed class="mr-2" @click="form_search = false">
              Close
            </v-btn>

            <v-btn
              color="primary"
              rounded
              depressed
              :loading="loading"
              v-on:click="getData()"
            >
              Filter
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment"
import StatusVue from "../component/Status.vue"

export default {
  components: {
    status: StatusVue,
  },
  methods: {
    getData() {
      var self = this
      var url = self.base_url + "material/dashboard/slaReport"
      self.loading = true
      self.form_search = false

      var data = {
        material_number: self.material_number,
        request_no: self.request_no,
        cataloguer: self.cataloguer,
        status: self.filter_status,
        plant: self.plant,
        startdate: self.date,
        enddate: self.date2,
        param: self.param_search,
      }

      if (self.storage_role === "REQ") {
        data.requester = self.storage_user_id
      }

      self.axios.post(url, data).then(function(response) {
        self.data = response.data
        self.loading = false
      })
    },
    exportData() {
      var self = this
      var url = self.base_url + "master/export/slaReport"

      var data = {
        material_number: self.material_number,
        request_no: self.request_no,
        cataloguer: self.cataloguer,
        plant: self.plant,
        startdate: self.date,
        enddate: self.date2,
        param: self.param_search,
      }

      var responseType = {
        responseType: "arraybuffer",
      }

      self.loadingDownload = true

      self.axios.post(url, data, responseType).then(function(response) {
        const blob = new Blob([response.data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })

        const url = window.URL.createObjectURL(blob)
        const link = document.createElement("a")
        link.href = url
        link.setAttribute("download", "sla_report.xlsx")
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        self.loadingDownload = false
      })
    },
    reset() {
      var self = this
      self.plant = ""
      self.date = ""
      self.date2 = ""
      self.material_number = ""
      self.request_no = ""
      self.filter_status = ""
      self.cataloguer = ""

      this.getData()
    },
    getPlant() {
      var self = this
      var url = self.base_url + "master/dropdown/attribute/plant/plant_code"
      self.axios.get(url).then(function(response) {
        self.list_plant = response.data
      })
    },
    getDateMonth() {
      this.date = moment()
        .startOf("month")
        .format("YYYY-MM-DD")
      this.date2 = moment()
        .endOf("month")
        .format("YYYY-MM-DD")
    },

    formSearch() {
      this.form_search = true
    },

    getCataloguer() {
      var self = this
      var url = self.base_url + "master/dropdown/user_cataloguer"
      self.axios.get(url).then(function(response) {
        self.list_cataloguer = response.data
      })
    },
  },
  mounted() {
    if (
      this.storage_role != "CAT" &&
      this.storage_role != "ADM" &&
      this.storage_role != "APP1" &&
      this.storage_role != "REQ"
    ) {
      this.$router.push("/login")
    }

    // this.getDateMonth()
    this.getData()
    this.getPlant()
    this.getCataloguer()
  },
  data() {
    return {
      name: "AverageSLA",
      title: "Average SLA",
      loading: false,
      loadingDownload: false,
      date: "",
      date2: "",
      material_number: "",
      request_no: "",
      requester: "",
      cataloguer: "",
      filter_status: "",
      data: [],
      list_plant: [],
      plant: null,
      request: 0,
      review: 0,
      done: 0,
      form_search: false,
      param_search: "",
      menu: false,
      menu2: false,
      headers: [
        { text: "Request No.", value: "request_no", width: 220 },
        { text: "Item Description", value: "description", width: 350 },
        { text: "Plant", value: "plant_name", width: 150 },
        { text: "Material Number", value: "material_number", width: "160" },
        { text: "Requester", value: "requester", width: 220 },
        { text: "Cataloguer", value: "cataloguer", width: 220 },
        { text: "Approver", value: "approver", width: 220 },
        { text: "Created Date", value: "inserted_date", width: 190 },
        { text: "Submited Date", value: "submit_date", width: 190 },
        { text: "Catalogued Date", value: "cataloguer_date", width: 190 },
        {
          text: "Cataloguing Duration (day)",
          value: "cataloguer_datediff",
          width: 210,
          align: "center",
        },
        { text: "Approved Date", value: "approver_date", width: 190 },
        {
          text: "Approval Duration (day)",
          value: "approver_datediff",
          width: 210,
          align: "center",
        },
        {
          text: "Register to SAP Date",
          value: "register_sap_date",
          width: 190,
        },
        {
          text: "Sending to SAP Duration (day)",
          value: "register_sap_datediff",
          width: 230,
          align: "center",
        },
        { text: "status", value: "status", width: 190 },
      ],

      list_status: [
        { STATUS_ID: "DRAFT", STATUS_NAME: "Draft" },
        { STATUS_ID: "APP1", STATUS_NAME: "Waiting Approval" },
        { STATUS_ID: "CAT", STATUS_NAME: "Waiting Cataloguing" },
        { STATUS_ID: "DRAFT_CAT", STATUS_NAME: "Waiting Send to SAP" },
        { STATUS_ID: "REG", STATUS_NAME: "Registered On SAP" },
        { STATUS_ID: "FAIL", STATUS_NAME: "Failed" },
        { STATUS_ID: "RJT", STATUS_NAME: "Rejected" },
      ],

      //storage.....................................
      storage_user_id: atob(localStorage.getItem("user_id")),
      storage_username: atob(localStorage.getItem("username")),
      storage_fullname: atob(localStorage.getItem("fullname")),
      storage_company_id: atob(localStorage.getItem("company_id")),
      storage_company_name: atob(localStorage.getItem("company_name")),
      storage_role: atob(localStorage.getItem("role")),
      storage_server: atob(localStorage.getItem("server")),
      storage_departement_id: atob(localStorage.getItem("departement_id")),
    }
  },
}
</script>
